module.exports = __webpack_public_path__ + "img/instellingen-icon.11997b1.png";